<app-grid-addition style="padding: 20px; margin-right:20px" [gridColumns]="gridColumns"
               [gridRecords]="gridRecords"
               (refresh)="onRefreshGridAddition($event)"
               (loading)="onLoadingDetail($event)"
               (cellPrepared)="onCellPrepared($event)"
               [employeeDataSource]="employeesNotQuit" [additionTypeDataSource]="additionTypeDataSource" 
               [projectIds]="projectIds"
               [visibleIndexProject]="3"
               [(showTransportColumn)]="showTransportColumn"
               [newStatusId]="3"
               [newCategoryId]="9"
               (showAdditionGrid)="onShowAdditionGrid($event)"
               (editingStart)="onEditingStart($event)"
               [doEmitDataSource]="true" (emitDataSource)="onDataSourceEmittedAddition($event)" >
</app-grid-addition>